import { createFileRoute, Outlet, retainSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import classes from './dashboard.module.css';
import { DEFAULT_SYSTEM_PROMPT } from '#components/chat/backends/AtlasAiBackend/constants';

export const Route = createFileRoute('/dashboard')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      startDate: z.string().nullable().optional(),
      endDate: z.string().nullable().optional(),
    }),
  ),
  search: {
    middlewares: [retainSearchParams(['startDate', 'endDate'])],
  },
  loader: (): {
    chatContext: Promise<{
      systemPrompt?: string;
    }>;
  } => ({
    chatContext: Promise.resolve({
      systemPrompt: DEFAULT_SYSTEM_PROMPT,
    }),
  }),
});

function RouteComponent() {
  return (
    <div className={classes.main}>
      <Outlet />
    </div>
  );
}
